import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

const PRIVACY_HTML =
  '<h2>Your Privacy</h2><p><span data-type="field-token" data-field="property_name"></span> respects your privacy. Information you share through this website, such as your name, email, and phone number, is used only to respond to your inquiry, schedule tours, and process rental applications.</p><h2>How We Use Information</h2><p>We may use cookies and analytics tools to understand how visitors use this site and to improve it. We do not sell your personal information.</p><h2>Contact</h2><p>Questions about this policy? Reach our leasing team at <span data-type="field-token" data-field="property_phone"></span>.</p>';

const ACCESSIBILITY_HTML =
  '<h2>Our Commitment</h2><p><span data-type="field-token" data-field="property_name"></span> is committed to making this website accessible to everyone, including people with disabilities. We continually review the site against the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA.</p><h2>Need Assistance?</h2><p>If you have trouble accessing any content on this site, please call us at <span data-type="field-token" data-field="property_phone"></span> and we will gladly help.</p>';

interface LegalContentProps {
  tokenPrefix?: string;
  variant?: 'privacy' | 'accessibility';
}

/** Long-form policy copy (privacy, accessibility) on a narrow reading column. */
export function LegalContent({ tokenPrefix, variant }: LegalContentProps) {
  const prefix = tokenPrefix || 'legalcontent';
  const bodyPath = `${prefix}.body`;
  const fallback = variant === 'accessibility' ? ACCESSIBILITY_HTML : PRIVACY_HTML;

  return (
    <section className="bg-background pb-16 pt-4 md:pb-24">
      <RichTextContent
        path={bodyPath}
        defaultValue={fallback}
        as="div"
        className="js-reveal js-copy mx-auto max-w-[860px] px-6 text-foreground [&_h2]:font-heading [&_h2]:leading-tight [&_h2]:mb-3 [&_h2]:mt-10 [&_h2]:text-[26px] [&_h2]:font-bold [&_h2]:uppercase [&_h2]:text-secondary first:[&_h2]:mt-0"
      />
      <RichTextContent path="legalcontent.body" as="div" className="hidden" style={{ display: 'none' }} />
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'LegalContent',
  displayName: 'Policy Content',
  tokens: {
    'legalcontent.body': {
      label: 'Policy Text',
      type: 'richtext',
      defaultValue:
        '<p><span data-type="field-token" data-field="property_name"></span> is committed to protecting your privacy and making this site accessible to everyone.</p>',
    },
  },
};

(LegalContent as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default LegalContent;
